import { readonlyRecord } from "fp-ts";
import { pipe } from "fp-ts/lib/function";

export function hasOwnProperty<X extends {}, Y extends PropertyKey>(obj: X, prop: Y): obj is X & Record<Y, unknown> {
  return obj.hasOwnProperty(prop);
}

export const pick = <T, K extends keyof T>(object: T, keys: K[]): Pick<T, K> =>
  keys.reduce((acc, key) => ({ ...acc, [key]: object[key] }), {} as Pick<T, K>);

export const mapRecord = <K extends string, A, B>(record: Record<K, A>, mapFn: (value: A) => B) =>
  pipe(record, readonlyRecord.fromRecord, readonlyRecord.map(mapFn), readonlyRecord.toRecord);
